import * as React from "react";

function SvgIcDamage(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 2.5a1 1 0 01.914.594L14.017 6.7l5.098-2.124a1 1 0 011.204 1.496l-2.794 3.992 2.369 1.016a1 1 0 01.23 1.7l-1.84 1.472 2.09 3.761a1 1 0 01-1.321 1.38l-4.997-2.498-1.616 4.446a1 1 0 01-1.916-.125l-.745-3.352-3.908 1.564a1 1 0 01-1.265-1.376l1.605-3.21-3.766-2.51a1 1 0 01.338-1.81l3.25-.721-1.927-3.855a1 1 0 011.38-1.321L9.03 6.595l1.556-3.501A1 1 0 0111.5 2.5zm0 3.462l-1.086 2.444a1 1 0 01-1.4.468l-1.674-.93 1.054 2.109a1 1 0 01-.677 1.423l-2.212.492 2.55 1.7a1 1 0 01.34 1.28l-.824 1.647 2.558-1.023a1 1 0 011.347.711l.256 1.152.828-2.277a1 1 0 011.387-.552l3.109 1.554-.93-1.674a1 1 0 01.25-1.267l1.196-.957-1.966-.843a1 1 0 01-.425-1.492l1.525-2.18-2.821 1.176a1 1 0 01-1.299-.517L11.5 5.962z"
        fill="currentColor"
      />
      {/* <path
        d="M8 1h8v-2H8v2zm15 7v8h2V8h-2zm-7 15H8v2h8v-2zM1 16V8h-2v8h2zm7 7a7 7 0 01-7-7h-2a9 9 0 009 9v-2zm15-7a7 7 0 01-7 7v2a9 9 0 009-9h-2zM16 1a7 7 0 017 7h2a9 9 0 00-9-9v2zM8-1a9 9 0 00-9 9h2a7 7 0 017-7v-2z"
        fill="#F22929"
      /> */}
    </svg>
  );
}

export default SvgIcDamage;
